import React, { ReactNode } from 'react';
import Header from './Header';
import Footer from './Footer';
import Breadcrumb from '../common/Breadcrumb';

interface LayoutProps {
  children: ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="layout">
      <Header />
      <main className="main-content">
        <Breadcrumb />
        <div className="content-wrapper">
          {children}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
